import { render, staticRenderFns } from "./VoDHome.vue?vue&type=template&id=33bae676"
import script from "./VoDHome.vue?vue&type=script&lang=ts"
export * from "./VoDHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports